import React from "react";
import { RootAnswers } from "../../components";
import { AnswerHelper, AnswerInterface, ApiHelper, PendingCommand, PlaylistInterface, QuestionInterface, SubscriptionInterface } from "../../helpers";

interface Props {
  subscriptionData?: any,
  playlist: PlaylistInterface,
  saveCallback: (playlistId: number) => void,
  pendingCommand: PendingCommand,
  sendCommand?: (cmd: PendingCommand) => void
}

export const PlaylistAnswers: React.FC<Props> = props => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null);
  const [answers, setAnswers] = React.useState<AnswerInterface[]>([]);

  const init = () => { if (props.playlist) loadQuestions(); }

  const loadQuestions = async () => {
    if (props.playlist.id > 0) ApiHelper.get<AnswerInterface[]>("/answers/playlist/" + props.playlist.id.toString())
      .then(data => setAnswers(data || []))
      .catch(err => console.error("Failed to load playlist answers:", err));

    let feedId = 0;
    if (props.playlist?.subscriptionId) {
      const sub = await ApiHelper.get<SubscriptionInterface>("/subscriptions/" + props.playlist?.subscriptionId.toString())
      feedId = sub?.feedId || 0;
    } else if (props.playlist?.mode === "slideshow") {
      feedId = 46;
    }
    if (feedId > 0) ApiHelper.get<QuestionInterface[]>("/questions/feed/" + feedId.toString())
      .then(data => setQuestions(data || []))
      .catch(err => console.error("Failed to load feed questions:", err));
  }


  const handleSave = async (playlistId: number) => {
    answers.forEach(a => a.playlistId = playlistId);
    await AnswerHelper.preSave(answers, questions, (percent) => {
      props.sendCommand({ action: "updateProgress", parameter: percent })
    });

    if (answers.length > 0) await ApiHelper.post("/answers", answers);
    props.saveCallback(playlistId);
  }

  const handleParentCommand = () => {
    if (props.pendingCommand) {
      switch (props.pendingCommand.action) {
        case "save":
          handleSave(parseInt(props.pendingCommand.parameter as string, 0));
          break;
      }
    }
  }

  React.useEffect(handleParentCommand, [props.pendingCommand]); // eslint-disable-line
  React.useEffect(init, [props.playlist]); // eslint-disable-line

  return (
    <RootAnswers subscriptionData={props.subscriptionData} questions={questions} answers={answers} playlistId={props.playlist.id} sendCommand={props.sendCommand} />
  );
};